module.exports = __webpack_public_path__ + "img/logo2.76d9b427.jpg";